module.exports = __webpack_public_path__ + "static/email-template-account-activation-elephanty-6da5ea838cd63266a3b8f57ff6e3abea.jpg";